const getBackgroundPosterObj = images => {
    if(images && images.poster &&  images.poster.url ) {
        return images.poster
    } else {
        return false
    }
}

export default getBackgroundPosterObj